module.exports = {
      id: "ic-countdown-light-normal-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-countdown-light-normal-usage",
      toString: function () {
        return this.url;
      }
    }